namespace Solovis.Reports.Layouts {

    export class HorizontalLayoutPart extends LayoutPart {

        constructor(options) {
            super(options);
        }

        public createPart(parentElement) {
            var self = this;

            if (this.partDefinition.useTableLayout) {
                var tableDiv = $("<table>").addClass("report-horizontal-layout").appendTo(parentElement);
                var tableBodyDiv = $("<tbody>").appendTo(tableDiv);
                var rowDiv = $("<tr>").appendTo(tableBodyDiv);

                this.layoutDiv = tableDiv;
                this.layoutDiv.css("display", "none");

                if (this.partDefinition.style) {
                    this.reportControl._applyStyleToPartContainer(this.partDefinition.style, this.layoutDiv);
                }

                if (this.partDefinition.children) {
                    $(this.partDefinition.children).each(function (i, child) {
                        var cellDiv = $("<td>").appendTo(rowDiv);
                        var childPart = self.reportControl._createPartContainer({ parentElement: cellDiv, partDefinition: child });
                        self.childPartList.push(childPart);
                    });
                }
            }
            else {
                this.layoutDiv = $("<div>").addClass("report-horizontal-layout").appendTo(parentElement)
                    .css("display", "none");

                if (this.partDefinition.style) {
                    this.reportControl._applyStyleToPartContainer(this.partDefinition.style, this.layoutDiv);
                }

                if (this.partDefinition.children) {
                    $(this.partDefinition.children).each(function (i, child: any) {
                        var horizontalBlock = $("<div>").addClass("report-horizontal-block").appendTo(self.layoutDiv);
                        if (child.parentStyle) {
                            self.reportControl._applyStyleToPartContainer(child.parentStyle, horizontalBlock);
                        }
                        var childPart = self.reportControl._createPartContainer({ parentElement: horizontalBlock, partDefinition: child });
                        self.childPartList.push(childPart);
                    });
                }
            }
        };
    }

}